(() => {
  'use strict';
  const root = document.querySelector('[data-jrw-ornament]');
  if (!root) return;
  const personalize = root.querySelector('[data-jrw-personalize]');
  const add = root.querySelector('[data-jrw-add]');
  const error = root.querySelector('[data-jrw-error]');
  const status = root.querySelector('[data-jrw-status]');
  const price = root.querySelector('[data-jrw-price]');
  const fields = [...root.querySelectorAll('[data-jrw-field]')];
  const inputs = [...root.querySelectorAll('[data-jrw-input]')];
  const enabled = root.dataset.personalizationEnabled === 'true';
  const standardId = root.dataset.standardVariantId;
  const personalizedId = root.dataset.personalizedVariantId;
  const setError = (message) => { error.textContent = message || ''; error.hidden = !message; };
  const setStatus = (message) => { status.textContent = message || ''; };
  const update = () => {
    const active = Boolean(personalize?.checked && enabled);
    fields.forEach((field) => { field.hidden = !active; });
    const color = root.querySelector('[data-jrw-color-field]');
    if (color) color.hidden = !active;
    if (!active) inputs.forEach((input) => { input.value = ''; });
    if (price) price.textContent = active ? 'Personalized: price is the Shopify Personalized variant' : 'Standard: price is the Shopify Standard variant';
  };
  const validate = (active) => {
    if (!active) return '';
    for (const input of inputs) {
      if (input.dataset.jrwRequired === 'true' && !input.value.trim()) return `${input.dataset.jrwInput} is required for this design.`;
      if (input.value.length > Number(input.maxLength)) return `${input.dataset.jrwInput} is too long for this design.`;
    }
    if (!/^\d{4}$/.test(inputs.find((input) => input.dataset.jrwInput === 'year')?.value || '')) return 'Year must be four digits.';
    return '';
  };
  const unitKey = () => globalThis.crypto?.randomUUID?.() || `jrw-${Date.now()}-${Math.random().toString(16).slice(2)}`;
  async function addToCart() {
    if (add.dataset.busy === 'true') return;
    const active = Boolean(personalize?.checked && enabled);
    const problem = validate(active);
    setError(problem);
    if (problem) return;
    const variantId = active ? personalizedId : standardId;
    if (!variantId) { setError('This review product has no valid Shopify variant.'); return; }
    add.dataset.busy = 'true'; add.disabled = true; setStatus('Adding one unit…');
    const properties = {
      '_jrw_schema_version': root.dataset.schemaVersion || '',
      '_jrw_design_id': root.dataset.designId || '',
      '_jrw_template_id': root.dataset.templateId || '',
      '_jrw_template_revision': root.dataset.templateRevision || '',
      '_jrw_unit_key': unitKey(),
      'JRW personalization': active ? 'Yes' : 'No'
    };
    if (active) {
      inputs.forEach((input) => { properties[input.dataset.jrwInput] = input.value; });
      const color = root.querySelector('[data-jrw-color]'); if (color) properties.Color = color.value;
    }
    try {
      const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, { method: 'POST', headers: {'Content-Type':'application/json','Accept':'application/json'}, body: JSON.stringify({items:[{id:Number(variantId), quantity:1, properties}]}) });
      if (!response.ok) throw new Error('Cart rejected the item.');
      const payload = await response.json();
      const item = payload.items?.[0];
      const actual = item && Number.isFinite(item.price) ? ` Shopify charged ${new Intl.NumberFormat(undefined,{style:'currency',currency:window.Shopify.currency.active}).format(item.price / 100)} for this ${active ? 'Personalized' : 'Standard'} variant.` : '';
      setStatus(`Added one ${active ? 'Personalized' : 'Standard'} unit.${actual}`); setError('');
    } catch (e) { setStatus(''); setError(e instanceof Error ? e.message : 'Unable to add this unit.'); }
    finally { add.dataset.busy = 'false'; add.disabled = false; }
  }
  personalize?.addEventListener('change', update); add.addEventListener('click', addToCart); update();
})();
